import { ScheduledPaymentsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchScheduledPayments() {
  const [fetching, setFetching] = useState(false);

  async function fetchScheduledPayments(params: ScheduledPaymentsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchScheduledPayments(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchScheduledPayments };
}
